import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=04c3c8b2&scoped=true&"
import script from "./Step2.vue?vue&type=script&lang=js&"
export * from "./Step2.vue?vue&type=script&lang=js&"
import style0 from "./Step2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Step2.vue?vue&type=style&index=1&id=04c3c8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c3c8b2",
  null
  
)

component.options.__file = "Step2.vue"
export default component.exports